import {Component} from '@angular/core';
import {BreadcrumbComponent} from "@shared/components/breadcrumb/breadcrumb.component";
import {
  PrescriptionByIdPatientComponent
} from "../../../prescription/prescription-list/prescription-by-id-patient/prescription-by-id-patient.component";
import {TopWidgetsComponent} from "@shared/components/top-widgets/top-widgets.component";

@Component({
  selector: 'app-patient-my-prescriptions',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    PrescriptionByIdPatientComponent,
    TopWidgetsComponent
  ],
  templateUrl: './patient-my-prescriptions.component.html',
  styleUrl: './patient-my-prescriptions.component.scss'
})
export class PatientMyPrescriptionsComponent {

}
